module.exports = __webpack_public_path__ + "img/firSub4.683523c1.png";